// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tracking-container {
    width: 100%;
    padding: 20px;
  }
  
  .tracking-progress {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    width: 100%;
  }
  
  .step-container {
    display: flex;
    align-items: center; /* Align icons horizontally */
    position: relative;
  }
  
  .step {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    padding: 10px;
    transition: all 0.3s ease;
  }
  
  .step-icon {
    font-size: 24px;
    margin-bottom: 8px;
  }
  
  .step p {
    margin: 0;
    font-size: 12px;
  }
  
  .step.active {
    font-weight: bold;
    color: #007bff;
  }
  
  .step.completed {
    color: #28a745;
  }
  
  .step-line {
    width: 40px; /* Adjust the width of the line */
    height: 2px; /* Line thickness */
    background-color: #007bff; /* Line color */
  }
  
  .active-step-content {
    margin-top: 20px;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 8px;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/Finance/OrderTracking.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB,EAAE,6BAA6B;IAClD,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW,EAAE,iCAAiC;IAC9C,WAAW,EAAE,mBAAmB;IAChC,yBAAyB,EAAE,eAAe;EAC5C;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB","sourcesContent":[".tracking-container {\n    width: 100%;\n    padding: 20px;\n  }\n  \n  .tracking-progress {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    width: 100%;\n  }\n  \n  .step-container {\n    display: flex;\n    align-items: center; /* Align icons horizontally */\n    position: relative;\n  }\n  \n  .step {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    cursor: pointer;\n    padding: 10px;\n    transition: all 0.3s ease;\n  }\n  \n  .step-icon {\n    font-size: 24px;\n    margin-bottom: 8px;\n  }\n  \n  .step p {\n    margin: 0;\n    font-size: 12px;\n  }\n  \n  .step.active {\n    font-weight: bold;\n    color: #007bff;\n  }\n  \n  .step.completed {\n    color: #28a745;\n  }\n  \n  .step-line {\n    width: 40px; /* Adjust the width of the line */\n    height: 2px; /* Line thickness */\n    background-color: #007bff; /* Line color */\n  }\n  \n  .active-step-content {\n    margin-top: 20px;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
